import React, { useContext, useEffect } from 'react';
import Drawer from './drawer';
import HeaderBar from './header-bar';
import { DrawerContext } from '../../contexts/drawer';
import { useIsSignedIn } from '../../api/hooks/auth';
import Modal from './modal';
import { Alert, Box, Snackbar, Stack } from '@mui/material';
import { ToastContext } from '../../contexts/toast';

export default function PageLayout({ children, pageTitle }) {
  const [modalOpen, setModalOpen] = useContext(DrawerContext);
  const { open: toastOpen, setOpen: setToastOpen, variant, content } = useContext(ToastContext);
  const isSignedIn = useIsSignedIn();

  useEffect(() => {
    isSignedIn();
  }, []);

  return (
    <>
      <Box direction="row" minHeight="100vh" sx={{ display: { xs: 'block', md: 'flex' } }}>
        <Drawer open={modalOpen} setOpen={setModalOpen} />
        <Stack sx={{ flexGrow: 1, minHeight: { xs: '100vh', md: 'initial' } }}>
          <HeaderBar open={modalOpen} setOpen={setModalOpen} title={pageTitle} />
          <Box sx={{ flexGrow: 1, p: 3, backgroundColor: 'background.main' }}>
            <main>{children}</main>
            <Modal />
          </Box>
        </Stack>
      </Box>
      <Snackbar
        open={toastOpen}
        autoHideDuration={6000}
        onClose={() => setToastOpen(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Alert onClose={() => setToastOpen(false)} severity={variant} sx={{ width: '100%' }}>
          {content}
        </Alert>
      </Snackbar>
    </>
  );
}

// const useStyles = makseStyles((theme) => {
//     return {
//         root: {
//             display: 'flex',
//         },
//         title: {
//             flexGrow: 1
//         },
//         appBar: {
//             zIndex: theme.zIndex.drawer + 1,
//             transition: theme.transitions.create(['width', 'margin'], {
//                 easing: theme.transitions.easing.sharp,
//                 duration: theme.transitions.duration.leavingScreen,
//             }),
//         },
//         appBarShift: {
//             marginLeft: drawerWidth,
//             width: `calc(100% - ${drawerWidth}px)`,
//             transition: theme.transitions.create(['width', 'margin'], {
//                 easing: theme.transitions.easing.sharp,
//                 duration: theme.transitions.duration.enteringScreen,
//             }),
//         },
//         menuButton: {
//             marginRight: 36,
//         },
//         hide: {
//             display: 'none',
//         },
//         content: {
//             flexGrow: 1,
//             padding: theme.spacing(3),
//         },
//         toolbar: {
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'flex-end',
//             padding: theme.spacing(0, 1),
//             ...theme.mixins.toolbar,
//         },
//     }
// });
